import {getTransferByIdService, getTransfersService} from "@/services/transfers.service";
import {useQuery} from "@tanstack/react-query";

const TRANSFERS_KEY = ["transfers"] as const;

interface TransferFilters {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  from?: string;
  to?: string;
}

export const useTransfers = (filters: TransferFilters = {}) =>
  useQuery({
    queryKey: [...TRANSFERS_KEY, filters],
    queryFn: async () => {
      const {data} = await getTransfersService(filters);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useTransfer = (id: string) =>
  useQuery({
    queryKey: [...TRANSFERS_KEY, id],
    queryFn: async () => {
      const {data} = await getTransferByIdService(id);
      if (data === undefined) throw new Error("No data");
      return data;
    },
    enabled: !!id,
  });
